export default "__VITE_ASSET__CubngM4M__"